const initialState = {
    isReadingCampaigns: false,
    campaigns: [],
    campaigns_count: 0
}

export default initialState;
